type SliceDataByParamsParams<T> = {
    data: Array<T>,
    pageNumber: number,
    pageSize: number,
};

export const sliceDataByParams = <T>(params: SliceDataByParamsParams<T>): Array<T> => {
    const {data, pageNumber, pageSize} = params;
    const from = (pageNumber - 1) * pageSize;

    return data.slice(from, from + pageSize);
};
